import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';

/**
 * Fetch checkout data including bookable dates
 * 
 * @param {string} shippingMethod - Selected shipping method
 * @returns {Promise<Object>} - Response data
 */
export const getSubscriptionCheckoutData = async (regularShippingMethod, subscriptionShippingMethod) => {
    const params = {
        regular_shipping_method: regularShippingMethod,
        subscription_shipping_method: subscriptionShippingMethod,
    };

    try {
        const response = await apiFetch({
            path: addQueryArgs('/iconic_wds/v1/get_subscription_checkout_data', params),
        });
        return response;
    } catch (error) {
        console.error('Error fetching checkout data:', error);
        throw error;
    }
}; 